"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

export const SoftAgeVerificationBirthDateFormInputsName = "Soft Age Verification BirthDateForm Inputs";

export const birthDateFormInputs = [
  {
    name: "headline",
    type: "string",
    defaultValue: "Are you over 18?",
  },
  {
    name: "description",
    type: "richText",
    defaultValue: "<p>You must be 18 years old to enter this site.</p><p>Please enter your birth date below.</p>",
  },
  {
    name: "dayPlaceholder",
    type: "string",
    defaultValue: "DD",
  },
  {
    name: "monthPlaceholder",
    type: "string",
    defaultValue: "MM",
  },
  {
    name: "yearPlaceholder",
    type: "string",
    defaultValue: "YYYY",
  },
  {
    name: "dayAriaLabel",
    type: "string",
    defaultValue: "Day",
  },
  {
    name: "monthAriaLabel",
    type: "string",
    defaultValue: "Month",
  },
  {
    name: "yearAriaLabel",
    type: "string",
    defaultValue: "Year",
  },
  {
    name: "validationMessage",
    type: "string",
    defaultValue: "Please enter a valid date",
  },
  {
    name: "minimumAge",
    type: "number",
    defaultValue: 18,
  },
  {
    name: "format",
    type: "string",
    enum: ["dd/mm/yyyy", "mm/yyyy", "yyyy"],
    required: true,
    defaultValue: "dd/mm/yyyy",
    showIf: `options.get("inputType") === "dropdowns"`,
  },
  {
    name: "format",
    type: "string",
    enum: ["dd/mm/yyyy", "yyyy/mm/dd", "yyyy"],
    required: true,
    defaultValue: "dd/mm/yyyy",
    showIf: `options.get("inputType") === "inputs"`,
  },
  {
    name: "inputType",
    type: "string",
    enum: ["inputs", "dropdowns"],
    required: true,
    defaultValue: "inputs",
  },
  {
    name: "isInputsHidden",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "regionSelectorTitle",
    type: "string",
    defaultValue: "Choose your location",
  },
] as const satisfies Inputs;

export const SoftAgeVerificationBirthDateFormInputsComponent: RegisteredComponent = {
  name: SoftAgeVerificationBirthDateFormInputsName,
  inputs: birthDateFormInputs,
  models: [getBuilderModelName("soft-age-verification")],
  defaultStyles: {
    width: "100%",
  },
  component: dynamic(async () => (await import("./BirthDateFormInputs")).BirthDateFormInputs),
};
